"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/Header/TeamPicker/PickerContent.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');



var _myRelations = require('shared/selectors/myRelations');
var _hooks = require('web/services/hooks');

var _Tooltip = require('web/components/Tooltip');
var _icons = require('../../icons');













const PickerItem = ({
  teamKey,
  selected,
  onSelectTeam,
  children,
}) => {
  const onClick = _react.useCallback.call(void 0, () => onSelectTeam(teamKey), [onSelectTeam, teamKey])

  return (
    _react2.default.createElement(_Tooltip.TooltipItem, {
      className: "inbox-picker--item",
      onClick: onClick,
      selected: selected,
      'aria-current': selected || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}

      , _react2.default.createElement('span', { className: "inbox-picker--item-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}},  children )
      ,  selected && _react2.default.createElement(_icons.CheckIcon, { className: "inbox-picker--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}} ) 
    )
  )
}

const PickerContent = ({
  selectedTeam,
  onSelectTeam,
}) => {
  const teamGroups = _hooks.useAppSelector.call(void 0, _myRelations.selectMyTeamGroupsList, _reactredux.shallowEqual)

  return (
    _react2.default.createElement(_Tooltip.TooltipContent, { className: "inbox-picker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
      , _react2.default.createElement(_Tooltip.TooltipTitle, { key: "title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Jump to…" )
      , _react2.default.createElement(PickerItem, {
        key: "all",
        teamKey: null,
        onSelectTeam: onSelectTeam,
        selected: selectedTeam === null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
, "My Inbox"

      )
      ,  teamGroups.map(g => (
        _react2.default.createElement(_react2.default.Fragment, { key: g.orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement('hr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 64}} )
          , _react2.default.createElement(_Tooltip.TooltipTitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 65}},  g.orgName )
          ,  g.teamsList.map(t => (
            _react2.default.createElement(PickerItem, {
              key: t.TeamKey,
              teamKey: t.TeamKey,
              onSelectTeam: onSelectTeam,
              selected: selectedTeam === t.TeamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}

              ,  t.Name 
            )
          ))
        )
      ))
    )
  )
}

exports. default = _react.memo.call(void 0, PickerContent)
